/**
 * Set Pending Prices Mode Action
 *
 * Action for setting pending prices mode in global store
 */

import { useBoundStoreBase } from "@frontend/lib/stores/globalStore";

/**
 * Set pending prices mode in global store
 * Used when proceeding with unverified insurance
 */
export const setPendingPricesMode = () => {
  const { setIsPendingPricesMode } = useBoundStoreBase.getState();
  setIsPendingPricesMode(true);
};

/**
 * Clear pending prices mode in global store
 * Used when disconnecting insurance
 */
export const clearPendingPricesMode = () => {
  const { setIsPendingPricesMode } = useBoundStoreBase.getState();
  setIsPendingPricesMode(false);
};

/**
 * Set storefront payment mode to CASH in global store
 * Used when user chooses to continue without insurance
 */
export const setStorefrontModeToCash = () => {
  const { setStorefrontPaymentMode } = useBoundStoreBase.getState();
  setStorefrontPaymentMode("CASH");
};

/**
 * Force the storefront into self-pay mode in the global store.
 *
 * Sets `storefrontPaymentMode` to "CASH" AND clears `isPendingPricesMode`.
 * Used for non-active insurance outcomes (inactive / out_of_network /
 * unverified-no-flag) where we still keep the insurance row around for
 * display/disconnect purposes, but pricing must be locked to self-pay so
 * the user can never flip to INSURED prices and see $0 / $NaN values.
 */
export const enforceSelfPayMode = () => {
  const { setStorefrontPaymentMode, setIsPendingPricesMode } =
    useBoundStoreBase.getState();
  setStorefrontPaymentMode("CASH");
  setIsPendingPricesMode(false);
};
